import api from 'service/api'
import humps from 'humps'
import history from 'service/history'
import { AUTH_TOKEN } from 'service/constants'

const marketPlaceAPI = api.create('marketPlace', false)

const login = async (data) => {
  const response = await marketPlaceAPI.post('/authentication', data)
  const token = response.data.authToken

  setToken(token)

  return response
}

const setToken = (token) => {
  localStorage.setItem(AUTH_TOKEN, token)
}

const getToken = () => {
  return localStorage.getItem(AUTH_TOKEN)
}

const logout = () => {
  history.push('/')
  localStorage.removeItem(AUTH_TOKEN)
}

const getUserIdFromToken = () => {
  const token = getToken()
  const payload = humps.camelizeKeys(JSON.parse(atob(token.split('.')[1])))

  return payload.userId
}

const isAuthenticated = () => {
  const token = getToken()
  return !!token
}

const auth = {
  login,
  logout,
  getToken,
  setToken,
  isAuthenticated,
  getUserIdFromToken,
}

export default auth
